export function getView(key) {
  switch (key) {
    case 'account_id': {
      return 'ITeroAccountSelector'
    }
    case 'doctor_id': {
      return 'ITeroDoctorSelector'
    }

    default: {
      return 'No'
    }
  }
}
